import { render, staticRenderFns } from "./object_select.vue?vue&type=template&id=e8fd826c&scoped=true"
import script from "./object_select.vue?vue&type=script&lang=js"
export * from "./object_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fd826c",
  null
  
)

export default component.exports